import home from "./tr-TR/home";
import nav from "./tr-TR/nav";

const messages_tr = {
    "app.title": "Yakışıklı Boilerplate",
    "app.subtitle": "Hadi başlayalım!",
    "app.language": "Dil",
    "app.OK": "Tamam",
    "app.Return": "Geri git",
    "app.selectLang": "Dili Ayarla",
    ...home,
    ...nav,
};

export default messages_tr;